import { useEffect, useState } from "react";
import { axiosGetWithHeader, ShowAlertError } from "../Common/axios";
import { AppHeader } from "./AppHeader";
import { useLocation } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { AppFooter } from "./AppFooter";

import { AstrologerInfoFooter } from "../Common/AstrologerInfoFooter";
import { BasicAstroMenu } from "./BasicAstroMenu";
import { RashiChartTab } from "./Basic/RashiChartTab";
import { BirthChartTab } from "./Basic/BirthChartTab";

export function BasicAstro()  {
  const {state} = useLocation();
  const runningId = state?state.runningId:null;
  const [refreshKey, setRefreshKey] = useState(1);
  const [userData, setUserData] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [birthHouseData, setBirthHouseData] = useState([]);
  const [navamsaHouseData, setNavamsaHouseData] = useState([]);
  const [planetaryPositionData, setPlanetaryPositionData] = useState([]);
  const [cuspalPositionData, setCuspalPositionData] = useState([]);
  const [menuArray, setMenuArray] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Rashi Chart Page');
  const [errorAlert, setErrorAlert] = useState(null);
  const handleMenu = (menuArray)=>setMenuArray(menuArray);
  const [birthChartType, setBirthChartType] = useState('0');

  useEffect(() => {
    axiosGetWithHeader("/userrequest/"+runningId,
      (response)=>{
        setUserData(response.data);
        getClientData(response.data.id);
        getBirthHouseData(response.data.id);
        getNavamsaHouseData(response.data.id);
        getPlanetaryPositionData(response.data.id);
        getCuspalPositionData(response.data.id);
        setSpinner(null);
      },
      (error)=>{
        setUserData(null);
        setSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );
    setRefreshKey(refreshKey);
  }, [runningId,refreshKey]);

  function getClientData(clientId) {
    axiosGetWithHeader("/chart/userdata/"+clientId,
      (response)=>{
        setClientData(response.data);
      },
      (error)=>{
        console.log(error);
        setClientData(null);
        setErrorAlert(error.message);
      }
    );
  }

  function getBirthHouseData(clientId) {
    axiosGetWithHeader("/chart/birthchart/"+clientId,
      (response)=>{
        setBirthHouseData(response.data.house);
        setBirthChartType(response.data.birthChartType);
      },
      (error)=>{
        console.log(error);
        setBirthHouseData(null);
        setBirthChartType(null);
        setErrorAlert(error.message);
      }
    );
  }

  function getNavamsaHouseData(clientId) {
    axiosGetWithHeader("/chart/navamsa/"+clientId,
      (response)=>{
        setNavamsaHouseData(response.data);
      },
      (error)=>{
        console.log(error);
        setNavamsaHouseData(null);
        setErrorAlert(error.message);
      }
    );
  }

  function getPlanetaryPositionData(clientId) {
    axiosGetWithHeader("/chart/planetarypositionchart/"+clientId,
      (response)=>{
        setPlanetaryPositionData(response.data);
      },
      (error)=>{
        console.log(error);
        setPlanetaryPositionData(null);
        setErrorAlert(error.message);
      }
    );
  }

  function getCuspalPositionData(clientId) {
    axiosGetWithHeader("/chart/cuspalpositionchart/"+clientId,
      (response)=>{
        setCuspalPositionData(response.data);
      },
      (error)=>{
        console.log(error);
        setCuspalPositionData(null);
        setErrorAlert(error.message);
      }
    );
  }

  return (
    <>
    <div class="m-0 p-0 row sticky-top bg-white noprint">
      <div class="m-0 p-0 col-12">
        <AppHeader/>
        <BasicAstroMenu userData={userData} handleMenu={handleMenu} />
      </div>    
    </div> 
    {spinner===null?<></>:<div class="text-center text-primary h5 pt-5">{spinner} <Spinner animation="border" size="sm" /></div>}
    { clientData===null || clientData===undefined || clientData.length===0 
        || userData===null || userData===undefined || userData.length===0
        || birthHouseData===null || birthHouseData===undefined || birthHouseData.length===0
        || navamsaHouseData===null || navamsaHouseData===undefined || navamsaHouseData.length===0
        || cuspalPositionData===null || cuspalPositionData===undefined || cuspalPositionData.length===0
        || planetaryPositionData===null || planetaryPositionData===undefined || planetaryPositionData.length===0 ?<div class="menupageheight"></div>:
    <>
      <div class="m-0 p-0 row align-items-top content">
        <div class="m-0 p-0 col-12">
          <div class="menupageheight">
            <RashiChartTab menuArray={menuArray} birthHouseData={birthHouseData} navamsaHouseData={navamsaHouseData} planetaryPositionData={planetaryPositionData} userData={userData} clientData={clientData} birthChartType={birthChartType} setBirthChartType={setBirthChartType}/>
            <BirthChartTab menuArray={menuArray} birthHouseData={birthHouseData} cuspalPositionData={cuspalPositionData} planetaryPositionData={planetaryPositionData} userData={userData} clientData={clientData} birthChartType={birthChartType} setBirthChartType={setBirthChartType}/>
          </div>  
        </div>
      </div>
    </>}
    <div class="m-0 p-0 row noprint">
      <div class="m-0 p-0 col-12">
        <AppFooter/>
      </div>    
    </div>
    <div class="m-0 p-0 row d-none d-print-block printfooter">
      <div class="m-0 p-0 col-12">
        <AstrologerInfoFooter userData={userData}  />
      </div>    
    </div> 
    <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
    </>
  );
}
